import Image from 'next/image'

import { ConsultRequestForm } from '../ConsultRequestForm'

import {
  Wrapper,
  Content,
  LeftSideWrapper,
  RightSideWrapper,
  ImageWrapper,
  DecorativeWrapper,
} from './styles'

export function ConsultRequest({ config, inOneLine }) {
  const {
    maxHeight,
    photoBlock,
    formBlock,
    decorativeItems,
    maxTitleWidth = null,
    textFont = {},
    marginTopMobile,
    widthImage,
    heightImage,
  } = config

  return (
    <Wrapper height={maxHeight} className="wrapper">
      <Content className="content">
        <LeftSideWrapper
          className="left-side-wrapper"
          marginTopMobile={marginTopMobile}
          widthImage={widthImage}
        >
          <ImageWrapper heightImage={heightImage} className="image-wrapper">
            <Image
              fill
              src={photoBlock.path}
              alt={photoBlock.alt}
              quality={100}
              priority
              sizes={100}
            />
          </ImageWrapper>
        </LeftSideWrapper>
        <RightSideWrapper className="right-side-wrapper">
          <ConsultRequestForm
            maxTitleWidth={maxTitleWidth}
            textFont={textFont}
            title={formBlock.title}
            subtitle={formBlock.subtitle}
            name={formBlock.personName}
            position={formBlock.personPosition}
            submitText={formBlock.submitText}
            inOneLine={inOneLine}
          />
        </RightSideWrapper>
        {decorativeItems.map(
          ({ path, width, height, alt, title, position }) => (
            <DecorativeWrapper {...position} key={title + height}>
              <Image
                src={path}
                width={width}
                height={height}
                alt={alt}
                quality={100}
              />
            </DecorativeWrapper>
          )
        )}
      </Content>
    </Wrapper>
  )
}
